import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import api from "@/lib/api";

export default function Legal({ tab }) {
  const [settings, setSettings] = useState(null);
  useEffect(() => {
    api.get("/public/settings").then((r) => setSettings(r.data)).catch(() => {});
  }, []);

  const isPrivacy = tab === "privacy";
  return (
    <div className="min-h-screen bg-[#0a0b0e] text-white">
      <div className="max-w-2xl mx-auto px-5 py-10">
        <Link to="/" className="flex items-center gap-1 text-[#a0a5b5] text-sm mb-6 hover:text-white transition-colors" data-testid="legal-back">
          <ArrowLeft className="w-4 h-4" /> Retour
        </Link>
        <h1 className="font-display text-3xl font-extrabold mb-6">
          {isPrivacy ? "Politique de confidentialité" : "Mentions légales"}
        </h1>
        <div className="space-y-5 text-[#a0a5b5] leading-relaxed">
          {isPrivacy ? (
            <>
              <p>{settings?.privacy_policy}</p>
              <div className="bg-[#161920] border border-[#262a33] rounded-xl p-4">
                <h3 className="text-white font-semibold mb-1">Durée de conservation</h3>
                <p className="text-sm">{settings?.data_retention}</p>
              </div>
              <div className="bg-[#161920] border border-[#262a33] rounded-xl p-4">
                <h3 className="text-white font-semibold mb-1">Suppression des données & consentement</h3>
                <p className="text-sm">
                  Le consentement pour être recontacté est facultatif et recueilli explicitement dans le formulaire.
                  Pour toute demande de suppression de vos données, contactez {settings?.email}.
                </p>
              </div>
            </>
          ) : (
            <p className="whitespace-pre-line">{settings?.legal_mentions}</p>
          )}
        </div>
      </div>
    </div>
  );
}
